/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quota_Exhausted_MessageInputs */

const en_quota_exhausted_message = /** @type {(inputs: Quota_Exhausted_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You have used all your time for the past 24h. The quota refills as old sessions roll off the sliding window.`)
};

const fr_quota_exhausted_message = /** @type {(inputs: Quota_Exhausted_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous avez utilisé tout votre temps sur les dernières 24h. Le quota se reconstitue au fur et à mesure que les anciennes sessions sortent de la fenêtre glissante.`)
};

const ms_sg2_quota_exhausted_message = /** @type {(inputs: Quota_Exhausted_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda telah menggunakan semua masa anda untuk 24 jam lepas. Kuota akan diisi semula apabila sesi lama keluar dari tingkap gelongsor.`)
};

/**
* | output |
* | --- |
* | "You have used all your time for the past 24h. The quota refills as old sessions roll off the sliding window." |
*
* @param {Quota_Exhausted_MessageInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const quota_exhausted_message = /** @type {((inputs?: Quota_Exhausted_MessageInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quota_Exhausted_MessageInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_quota_exhausted_message(inputs)
	if (locale === "fr") return fr_quota_exhausted_message(inputs)
	return ms_sg2_quota_exhausted_message(inputs)
});